module.exports = __webpack_public_path__ + "img/logo_09m.4fbf375b.png";